import apiInstance from "@services/Shared/instanceAxios";
import { TUpdatePasswordAccountDto } from "types/Core/Account/updatePasswordAccountDto";

const updatePassword = (
  uuid: string,
  updateDataPassword: TUpdatePasswordAccountDto
) =>
  apiInstance({
    url: "/account/" + uuid + "/account-password",
    method: "put",
    data: updateDataPassword,
  });

export default updatePassword;
